import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import http from '@/utils/http'

Vue.config.productionTip = false

//挂载到vue实例可以直接使用this来访问
Vue.prototype.http = http;


// 点击以外的
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
              // and if it did, call method provided in attribute value
              vnode.context[binding.expression](event)
          }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
  }
});

var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
    var hm = document.createElement("script");
    var src = 'https://hm.baidu.com/hm.js?a7640a55491d2e5cfc5f08935de8c039'
    hm.src = src;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
